import { createContext } from 'react';

export var RouterReactContext = createContext({ router: null });